import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "google/protobuf/empty.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime"; // @generated message type with reflection information, may provide speed optimized methods

var Empty$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(Empty$Type, _MessageType);

  var _super = _createSuper(Empty$Type);

  function Empty$Type() {
    _classCallCheck(this, Empty$Type);

    return _super.call(this, "google.protobuf.Empty", []);
  }

  _createClass(Empty$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Empty$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.Empty
 */


export var Empty = new Empty$Type();